module.exports = __webpack_public_path__ + "img/catalog-bg.9e1fe94e.png";